/**
 * @desc 暂存区明细列表/根据单号查询
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stagingAreaMaster.detailList.Params, options?: any) {
  return updateResponse(
    http(URL + `/stagingAreaMaster/detailList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
